import React from "react";
import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";

import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";

import { handleColumnsArrangement, handleColumnsWidth } from "../../lib/helpers/grid";
import { DateFormatter } from "../../lib/components/Formatters";

const cellWidthSmallX = 90;
const cellWidthSmall = 10;
const cellWidthMedium = 150;
const cellWidthLarge = 220;

const defaultColumnProperties = {
    resizable: true,
    sortable: true,
    filterable: true,
};

let currentSpace = true;

const StatusCell = (status: string, dirty: boolean, filename: string) => {
    // edited but not processed -> orange pencil icon
    if (dirty) {
        return (
            <div>
                <Tooltip title={`Updated ${filename || ""}`}>
                    <EditIcon
                        style={{
                            color: "orange",
                            display: "block",
                            margin: "auto",
                        }}
                    />
                </Tooltip>
            </div>
        );
    }
};

export const EDIValidationGrid = (
    data,
    filters,
    arrangement,
    columnsWidth
) => {
    let postValue = "";

    if (data) {
        if (currentSpace) {
            postValue = " ";
        }
        currentSpace = !currentSpace;
    }

    const bolRow = (row: any, content: React.ReactNode) => (
        <div style={{ fontWeight: row && row.isSelected ? "bold" : "normal" }}>
            {content}
        </div>
    );

    const columns = [
        {
            key: "status",
            name: "#S" + postValue,
            width: cellWidthSmall,
            formatter: ({ row }) =>
                bolRow(row, StatusCell(row.status, row.isDirty, row.filename)),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"statusLabel"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "timestamp",
            name: "Timestamp" + postValue,
            width: cellWidthMedium,
            formatter: (props) =>
                bolRow(props.row, <DateFormatter includeTime {...props} />),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"timestamp"}
                        data={data}
                        section={"edivalidation"}
                        orderDescending
                    />
                );
            },
        },
        {
            key: "fileType",
            name: "File Type" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.fileType),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"fileType"}
                        data={data}
                        section={"edivalidation"}
                    />
                );
            },
        },
        {
            key: "filename",
            name: "Filename" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.filename),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"filename"}
                        data={data}
                        section={"edivalidation"}
                    />
                );
            },
        },
        {
            key: "locationcode",
            name: "Location Code" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.locationcode),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"locationcode"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "receiver",
            name: "Receiver" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.receiver),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"receiver"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "waybillDocument",
            name: "Waybill Document" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.waybillDocument),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"waybillDocument"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "RegNo",
            name: "Truck Reg No" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.RegNo),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"RegNo"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "ContainerNo",
            name: "Container No" + postValue,
            width: cellWidthMedium,
            formatter: ({ row }) => bolRow(row, row.ContainerNo),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"ContainerNo"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "totalCartons",
            name: "Total Cartons" + postValue,
            width: cellWidthSmallX,
            formatter: ({ row }) => bolRow(row, row.totalCartons),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"totalCartons"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "totalPallets",
            name: "Total Pallets" + postValue,
            width: cellWidthSmallX,
            formatter: ({ row }) => bolRow(row, row.totalPallets),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"totalPallets"}
                        data={data}
                        section={"edivalidation"}
                        enableAutoFilter={true}
                    />
                );
            },
        },
        {
            key: "notes",
            name: "Notes" + postValue,
            width: cellWidthLarge,
            formatter: ({ row }) => bolRow(row, row.notes),
            filterRenderer: (e) => {
                return (
                    <CustomAutoCompleteFilter
                        {...e}
                        multiSelection={true}
                        currentFilters={filters}
                        fieldname={"notes"}
                        data={data}
                        section={"edivalidation"}
                    />
                );
            },
        },
    ].map((c) => ({ ...c, ...defaultColumnProperties }));

    let columnsArranged = [];
    columnsArranged = handleColumnsArrangement(columnsArranged, arrangement, columns);
    columnsArranged = handleColumnsWidth(columnsArranged, columnsWidth, columns);
    return columnsArranged;
};